import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#374047] text-white pt-16 pb-8" data-id="element-35">
      <div className="container mx-auto px-4 md:px-6" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-37">
          {/* Logo and about */}
          <div data-id="element-38">
            <Link to="/" className="inline-block mb-4" data-id="element-39">
              <span className="text-2xl font-bold text-white" data-id="element-40">
                Desta<span className="text-[#FF6B65]" data-id="element-41">Meet</span>
              </span>
            </Link>
            <p className="text-gray-300 mb-4" data-id="element-42">
              The Premier Destination Management Company, creating elevated
              group experiences that foster connection, reward excellence, and
              elevate organizational impact.
            </p>
            <div className="flex space-x-4" data-id="element-43">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#FF6B65] transition-colors" aria-label="Instagram" data-id="element-44">
                <InstagramIcon className="h-5 w-5" data-id="element-45" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#FF6B65] transition-colors" aria-label="LinkedIn" data-id="element-46">
                <LinkedinIcon className="h-5 w-5" data-id="element-47" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-48">
            <h3 className="text-lg font-semibold mb-4" data-id="element-49">Quick Links</h3>
            <ul className="space-y-2" data-id="element-50">
              <li data-id="element-51">
                <Link to="/solutions" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-52">
                  Solutions
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/agenda" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-54">
                  Sample Agenda
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/venues" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-56">
                  Venues
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/packages" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-58">
                  Packages & Pricing
                </Link>
              </li>
              <li data-id="element-59">
                <Link to="/destapass" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-60">
                  DestaPass - Wedding Platform
                </Link>
              </li>
            </ul>
          </div>

          {/* Partner Programs */}
          <div data-id="element-61">
            <h3 className="text-lg font-semibold mb-4" data-id="element-62">Partner Programs</h3>
            <ul className="space-y-2" data-id="element-63">
              <li data-id="element-64">
                <Link to="/trainer-partner-program" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-65">
                  Trainer Partner Program
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/vip-partner-program" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-67">
                  VIP Experience Partners
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/elevate-impact" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-69">
                  Complimentary Luxury Retreat
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/case-stories" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-71">
                  Case Stories
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/insights" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-73">
                  Insight Hub
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-74">
            <h3 className="text-lg font-semibold mb-4" data-id="element-75">Contact</h3>
            <ul className="space-y-2 mb-4" data-id="element-76">
              <li className="flex items-center" data-id="element-77">
                <PhoneIcon className="h-4 w-4 mr-2 text-[#FF6B65]" data-id="element-78" />
                <a href="tel:+14154170322" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-79">
                  +1 415 417 0322
                </a>
              </li>
              <li className="flex items-center" data-id="element-80">
                <MailIcon className="h-4 w-4 mr-2 text-[#FF6B65]" data-id="element-81" />
                <a href="mailto:events@destameet.com" className="text-gray-300 hover:text-[#FF6B65] transition-colors" data-id="element-82">
                  events@destameet.com
                </a>
              </li>
            </ul>
            <a href="https://wa.me/14169998778?text=I'd%20like%20to%20chat%20with%20you%20about%20DestaMeet" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 bg-[#25D366] text-white rounded-md hover:bg-opacity-90 transition-colors" data-id="element-83">
              <span data-id="element-84">WhatsApp Chat</span>
            </a>
            <div className="mt-4" data-id="element-85">
              <Link to="/about" className="text-gray-300 hover:text-[#FF6B65] transition-colors text-sm" data-id="element-86">
                About & ESG
              </Link>
              <span className="text-gray-600 mx-2" data-id="element-87">•</span>
              <Link to="/contact" className="text-gray-300 hover:text-[#FF6B65] transition-colors text-sm" data-id="element-88">
                Contact / RFP
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-gray-700" data-id="element-89">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-90">
            <p className="text-sm text-gray-400 mb-4 md:mb-0" data-id="element-91">
              &copy; {currentYear} DestaMeet. All rights reserved.
            </p>
            <div className="text-sm text-gray-400 flex flex-wrap justify-center gap-4" data-id="element-92">
              <span data-id="element-93">100% carbon-offset</span>
              <span className="hidden md:inline" data-id="element-94">•</span>
              <span data-id="element-95">Reef-restoration support</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}